<template>
	<div id="groups-events-hero-wrapper" class="tw-relative tw-overflow-hidden tw-flex tw-flex-col" :class="{'small': !has_image && !editing, 'live-room-header': is_live_event}">
		<image-uploader :width="1920" :height="500" :display="false" @upload="saveHeaderImage" @close="closeHeaderImageUploader" v-if="changing_header_image"></image-uploader>
		<div class="header-img tw-absolute tw-w-full" :class="{'live-room-header-img': is_live_event}" v-if="has_image || is_live_event">
            <img :class="{'disable-blur max-height': is_live_event}" :src="has_image ? model.image : '/img/coffee-and-chat.png'">
		</div>

		<div v-else class="tw-absolute tw-w-full tw-h-full tw-bg-white" :class="!editing ? 'header-color' : 'default-image'">

		</div>
		<div class="groups-events-header-content tw-flex-1">
			<div class="main-content-inner-wrapper no-padding-top" :class="{'tw-h-full': is_live_event}">
				<custom-form id="custom-form" contentClass="tw-w-3/4 tw-h-full" :class="{'tw-items-center': is_live_event}">
					<div class="tw-flex tw-flex-col tw-justify-between tw-flex-1 tw-z-10" :class="{'tw-text-white': has_image}">
						<div class="tw-flex tw-justify-between">
							<slot name="back-button"></slot>

							<div class="tw-inline-flex" v-if="editing && ((model.participation !== null && ['moderator', 'founder'].includes(model.participation.role)) || user.isModerator)">
								<div class="subtle-button tw-bg-white tw-text-gray-700 tw-text-sm" @click="openHeaderImageUploader">
									{{ translations['groups.edit_image'] }}
									<i class="far fa-image"></i>
								</div>
							</div>
						</div>

						<slot name="content"></slot>
					</div>
				</custom-form>
			</div>
		</div>
	</div>
</template>

<script>
import ImageUploader from '../ui/ImageUploader.vue';
import Notification from '../../lib/models/Notification';
import Global from '../../mixins/Global';

export default {
	name: 'EventsAndGroupsHeader',

	mixins: [Global],

	components: {
		'image-uploader': ImageUploader,
	},

	props: {
		model: {
			required: true,
		},

		editing: {
			required: true,
			type: Boolean,
		},

		model_name: {
			required: true,
			type: String,
		},

		has_image: {
			required: true,
			default: false,
			type: Boolean,
		},

		is_live_event: {
			required: false,
			default: false,
		}
	},

	data() {
		return {
			changing_header_image: false,
		};
	},

	methods: {
		openHeaderImageUploader() {
			this.changing_header_image = true;
		},

		closeHeaderImageUploader() {
			this.changing_header_image = false;
		},

		saveHeaderImage(data) {
			this.changing_header_image = false;

			this.model.image = data.base64;

			Notification.insert({
				data: [
					{
						title: 'Image updated.',
					},
				],
			});

			axios.post('/api/v3/uploads', {
				handler: 'base64',
				data: data.base64,
				filename: data.filename,
				model: this.model_name,
				modelId: this.model.id,
			}).catch(() => {
				Notification.insert({
					data: [
						{
							title: 'Image could not be updated.',
							status: 'error',
						},
					],
				});
			});
		},
	},
};
</script>

<style lang="scss">
@import '../../../../../assets/sass/fakebook/_mixins.scss';

#groups-events-hero-wrapper {
	width: 100%;
	height: 230px;

  .disable-blur {
    filter: none !important;
  }

  .max-height {
    height: 600px;
  }


  &.small {
		@apply tw-border-b tw-border-gray-0;
		height: 110px;

		.groups-events-header-content {
			.form-content {
				height: 72px;
			}
		}
	}

	&.live-room-header {
		height: 600px;
	}

	.live-room-header-img {
		min-height: 600px !important;

		img {
			min-height: 600px !important;
		}
	}

	.header-img {
		background: #000;
		min-height: 230px;

		img {
			@include better-blur(5);
			object-fit: cover;
			width: 100%;
			opacity: 0.7;
			min-height: 230px;
		}
	}

	.header-color {
		height: 110px;
	}

	.default-image {
		background: url('../../../../../../../../../../public/img/geometry_bg.png');
	}

	.groups-events-header-content {
		.group-title {
			h1 {
				@apply tw-mb-0;
			}
		}

		.form-content {
			margin-top: 1.35rem;
			height: 192px;
			margin-bottom: 1.35rem;

			.form-content-flex-wrapper {
				@apply tw-h-full;
			}
		}

		.groups-events-back-btn {
			@apply tw-flex tw-items-center tw-border tw-border-white tw-rounded tw-cursor-pointer;
			transition: background .2s, color .2s;
			padding: 10px;
			font-size: 12px;
			font-weight: 300;

			i {
				@apply tw-mr-2 tw-pt-px;
			}

			&:hover {
				@apply tw-bg-white tw-text-gray-700;
			}
		}

		@media(max-width: 767px) {
			@apply tw-px-6;
		}
	}
}
</style>
